import React, { Component } from 'react';
import Heading from '~/UI/Heading/Heading';

import image1 from './images/img1.jpg';
import image10 from './images/img10.jpg';
import image2 from './images/img2.jpg';
import image3 from './images/img3.jpg';
import image4 from './images/img4.jpg';
import image5 from './images/img5.jpg';
import image6 from './images/img6.jpg';
import image7 from './images/img7.jpg';
import image8 from './images/img8.jpg';
import image9 from './images/img9.jpg';
import styles from './styles.less';

interface Props {
	scrollOnExport: boolean;
}

export default class Instructions extends Component<Props> {
	static defaultProps = {
		scrollOnExport: false,
	};

	exportSectionElement: HTMLDivElement | null = null;

	componentDidMount() {
		if (this.props.scrollOnExport) {
			this.scrollOnExportSection();
		}
	}

	scrollOnExportSection() {
		this.exportSectionElement?.scrollIntoView(true);
	}

	render() {
		return (
			<div className={styles.content} data-testid='product-instructions'>
				<div className={styles.in}>
					<div className={styles.item}>
						<div className={styles.leftImage}>
							<img alt='' src={image1} />
						</div>
						<div className={styles.leftDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Search</Heading>
								<p className={styles.paragraph}>
									Enter search criteria into the search form. Add as many search parameters as you need to make the
									search more specific.
								</p>
							</div>
						</div>
					</div>

					<div className={styles.item}>
						<div className={styles.rightImage}>
							<img alt='' src={image2} />
						</div>
						<div className={styles.rightDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Go through the results</Heading>
								<p className={styles.paragraph}>
									Check the results and add more search parameters if needed. Additional data from the source datasets
									could be found on the detailed view of each product.
								</p>
							</div>
						</div>
					</div>

					<div className={styles.item}>
						<div className={styles.leftImage}>
							<img alt='' src={image3} />
						</div>
						<div className={styles.leftDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Select various products</Heading>
								<p className={styles.paragraph}>
									Use the checkbox to select products you wish to work with. Those products might be the ones you will
									later use for the price referencing or to monitor the market.
								</p>
							</div>
						</div>
					</div>

					<div className={styles.item}>
						<div className={styles.rightImage}>
							<img alt='' src={image4} />
						</div>
						<div className={styles.rightDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Create folder</Heading>
								<p className={styles.paragraph}>
									To organize the selected products, create a folder first. There are various folder types with specific
									features:{' '}
								</p>
								<ul className={styles.list}>
									<li className={styles.listItem}>
										National modules – product lists created in these folders (see the next step) allow a specific
										calculation according the valid national rules, such as max. price or reimbursement calculation
									</li>
									<li className={styles.listItem}>
										Other – organize other lists of products (market monitoring, competitors overview etc.) same as with
										a usual file manager.
									</li>
								</ul>
							</div>
						</div>
					</div>

					<div className={styles.item}>
						<div className={styles.leftImage}>
							<img alt='' src={image5} />
						</div>
						<div className={styles.leftDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Create list</Heading>
								<p className={styles.paragraph}>
									Products marked with checkbox can be added to product lists. Use various product lists to store
									related products. Name your product list for better organisation.
								</p>
							</div>
						</div>
					</div>

					<div className={styles.item}>
						<div className={styles.rightImage}>
							<img alt='' src={image6} />
						</div>
						<div className={styles.rightDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Added</Heading>
								<p className={styles.paragraph}>
									Your product list is created. Explore the price history log, email notification system about price
									changes, download function and many more.
								</p>
							</div>
						</div>
					</div>

					<div className={styles.contentHead}>
						<Heading level={1}>National Modules</Heading>
						<p className={styles.perex}>
							National modules follow the applicable regulations and differ in details. Usually, steps described in this
							section is the common process for all module types. Based on your subscription plan, not all features
							might be available. Contact <a href='mailto:support@cogvio.com'>support@cogvio.com</a> for more
							information.
						</p>
					</div>

					<div className={styles.item}>
						<div className={styles.leftImage}>
							<img alt='' src={image7} />
						</div>
						<div className={styles.leftDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Calculation parameters set-up </Heading>
								<p className={styles.paragraph}>
									Start with adding the calculation parameters for your products, such as package size, dosage strength
									and usual/defined daily dose. Sometimes, parameters are automatically imported from products already
									on the market. It is recommended to double check imported parameters.
								</p>
							</div>
						</div>
					</div>

					<div className={styles.item}>
						<div className={styles.rightImage}>
							<img alt='' src={image8} />
						</div>
						<div className={styles.rightDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Confirm reference prices</Heading>
								<p className={styles.paragraph}>
									National modules are calculating the reference price (usually ex-factory) according to valid national
									guidance. Sometimes, more ways of calculation are possible or your input is needed (e.g. various VAT
									for cold chain). Confirm manually all prices where indicated by <span className={styles.icoArrow} />
								</p>
							</div>
						</div>
					</div>

					<div className={styles.item} ref={(ref) => (this.exportSectionElement = ref)}>
						<div className={styles.leftImage}>
							<img alt='' src={image9} />
						</div>
						<div className={styles.leftDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Export your results </Heading>
								<p className={styles.paragraph}>Once ready, download your list to the XLS format.</p>
								<ul className={styles.list}>
									<li className={styles.listItem}>General Format - Product details list with prices</li>
									<li className={styles.listItem}>
										National Specific Format
										<ul className={styles.list}>
											<li className={styles.listItem}>CZ Max. Price, CZ Reimbursement – SUKL format</li>
											<li className={styles.listItem}>SK Max. Price – CNref (Ministry of Health) or raw</li>
										</ul>
									</li>
								</ul>
							</div>
						</div>
					</div>

					<div className={styles.item}>
						<div className={styles.rightImage}>
							<img alt='' src={image10} />
						</div>
						<div className={styles.rightDescription}>
							<div className={styles.descriptionContent}>
								<Heading level={2}>Output format </Heading>
								<p className={styles.paragraph}>
									The exported XLS is the standard national format and contains formulas for automatic calculation of
									various parameters and/or the final price (IRP - max. price or reimbursement).
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
